export const SHIPMENT_TIME_REQUEST = "SHIPMENT_TIME_REQUEST";
export const SHIPMENT_TIME_SUCCESS = "SHIPMENT_TIME_SUCCESS";
export const SHIPMENT_TIME_FAIL = "SHIPMENT_TIME_FAIL";